//OPERANDS
export enum OPERANDS {
  INCLUDES = "includes",
  EXCLUDES = "excludes",
  IS = "is",
  IS_NOT = "is not",
}

//API_OPERAND
export enum API_OPERAND {
  INCLUDES = "__includes",
  EXCLUDES = "__excludes",
  IS = "",
  IS_NOT = "__ne",
}

// WIDGETS_TYPE
export enum WIDGETS_TYPE {
  SINGLE_TEXT = "SingleTextWidget",
  MULTIPLE_DROPDOWN= "MultipleDropDownWidget",
  DOUBLE_TEXT = "RangeTextWidget",
  SPECIAL = "SPECIAL",
}

// WIDGETS_STATE
export enum WIDGETS_STATE {
  CLOSED = "CLOSED",
  EXPANDED = "EXPANDED",
  FILLED = "FILLED",
}
